import {
  EditorState, AtomicBlockUtils,
} from 'draft-js';
import ImgComponent from './img-component';

export function addImage(editorState, url, width) {
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity(
    'IMG',
    'IMMUTABLE',
    { src: url, width },
  );
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  console.log(entityKey);
  const newEditorState = AtomicBlockUtils.insertAtomicBlock(
    editorState,
    entityKey,
    ' ',
  );
  return EditorState.forceSelection(
    newEditorState,
    newEditorState.getCurrentContent().getSelectionAfter(),
  );
}

const createMyImgPlugin = (config) => {
  const comp = config.decorator ? config.decorator(ImgComponent) : ImgComponent;

  const blockRendererFn = (block, { getEditorState }) => {
    if (block.getType() === 'atomic') {
      const contentState = getEditorState().getCurrentContent();
      console.log(contentState.getEntity(block.getEntityAt(0)));

      const entity = block.getEntityAt(0);

      if (!entity) return null;
      const { type } = contentState.getEntity(entity);
      const { src, width } = contentState.getEntity(entity).getData();

      if (type === 'IMG') {
        return {
          component: comp,
          editable: false,
          props: {
            src,
            width,
          },
        };
      }
    }
    return null;
  };

  return {
    blockRendererFn,
    addImage,
  };
};

export default createMyImgPlugin;
